import { formatEasternTimeFirstDateTime } from '../../lib/formatters';

export const formatDateTime = (timestamp: number) =>
  formatEasternTimeFirstDateTime(timestamp);
